import React from 'react';
import {  FieldArray, reduxForm } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import RenderScoresTable from "./renderScoresTable";

const ScoreRecordFormTable =  (props) =>{
  const {scoreRecordSubmit, handleSubmit, scoreRecord, criteria, parseStore, parseCriterionFromFormTable,
    personHasScoredNewStoreForCriterion, getStoreScoreForCriterionAverageValue} = props;
  return (
    <form onSubmit={handleSubmit(scoreRecordSubmit)}>
      <div className={'form-group'}>
        <FieldArray
          name="stores"
          component={RenderScoresTable}
          props={{scoreRecord, criteria, parseStore, personHasScoredNewStoreForCriterion,
            getStoreScoreForCriterionAverageValue}}
          parseCriterionFromFormTable={parseCriterionFromFormTable}
        />
      </div>
      <Button type={'submit'} variant="contained" color="primary">
        {'Create'}
      </Button>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'scoreRecordFormTable'
})(ScoreRecordFormTable);



// WEBPACK FOOTER //
// ./src/components/scoreRecord/scoreRecordFormTable.js